import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { backButtonExclusions } from '../../constants';

interface BrowserBackHOCParams {
  children: JSX.Element;
}

export const BrowserBackHOC = (props: BrowserBackHOCParams): JSX.Element => {
  const history = useHistory();
  const location = useLocation();
  const [, setPath] = useState(location.pathname);

  useEffect(() => {
    setPath((prevPath) => {
      if (history.action === 'POP' && !backButtonExclusions.includes(prevPath)) {
        history.push(`${prevPath}${location.search}`);
      }

      return location.pathname;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return props.children;
};
